<div class="w-full h-full relative">
  <div id="wizard-content">
    <div class="flex flex-col items-center justify-center">
      <div class="flex flex-col justify-center max-w-lg">
        <h2 class="text-2xl font-semibold m-0 mb-6">Manage your Airbnb rule-sets in Hospitable</h2>
        <p class="m-0 mb-8">
          You've set up rule-sets in Airbnb. To manage them all in one place, you'll need to import them into
          Hospitable. You can preview the process before making any changes.
        </p>
        <div class="flex gap-4">
          <sbnb-button [type]="'secondary'" label="Not now" (click)="closeModal(true)"></sbnb-button>
          <sbnb-button label="Review rule-sets" (click)="reviewRuleSets()"></sbnb-button>
        </div>
      </div>
    </div>
  </div>
</div>
